import { useTranslation } from 'react-i18next'

import { AUTH_TRANSLATION_NAMESPACE } from '../translation'

export const useAuthTranslation = () =>
  useTranslation(AUTH_TRANSLATION_NAMESPACE)
